import React from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole page; each part uses its own slice of it */
import styles from './CatalogAddSong.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface StepHeaderProps {
  /** "Step 2 of 6", "Step 5 of 6 · optional". */
  eyebrow?: string;
  question: string;
  sub?: string;
}

/** The head of one step (design catalog-add-song a1): the step count, the question, one line under it. */
const StepHeaderComponent: React.FC<StepHeaderProps> = ({ eyebrow, question, sub }) => (
  <div>
    {eyebrow !== undefined && <div className={styles.eyebrow}>{eyebrow}</div>}
    {/* A long song title wraps and stops after four lines; the whole question is the tooltip (QA brk-18). */}
    <h1 className={styles.question} title={question}>
      {question}
    </h1>
    {sub !== undefined && <p className={styles.sub}>{sub}</p>}
  </div>
);

export const StepHeader = TypedMemo(StepHeaderComponent);
